import { IconButton, Dialog, DialogContent } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ContactAuditDialog = ({ audit, modalId, setModalId, children, width }) => {
    return modalId === audit.id ? (
        <Dialog open
            onClose={() => setModalId(null)}
            aria-labelledby="parent-modal-title"
            fullWidth
            maxWidth={width}
        >
            <IconButton
                aria-label="close"
                onClick={() => setModalId(null)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                {children}
            </DialogContent>
        </ Dialog>
    ) : null
};

export default ContactAuditDialog;